/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MyEntriesDisplayQueryVariables = {|
  contestId: string
|};
export type MyEntriesDisplayQueryResponse = {|
  +entrantsForContest: ?$ReadOnlyArray<?{|
    +id: string,
    +username: string,
  |}>
|};
export type MyEntriesDisplayQuery = {|
  variables: MyEntriesDisplayQueryVariables,
  response: MyEntriesDisplayQueryResponse,
|};
*/


/*
query MyEntriesDisplayQuery(
  $contestId: ID!
) {
  entrantsForContest(contestId: $contestId) {
    id
    username
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contestId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contestId",
        "variableName": "contestId"
      }
    ],
    "concreteType": "DraftKingsUserType",
    "kind": "LinkedField",
    "name": "entrantsForContest",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MyEntriesDisplayQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MyEntriesDisplayQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "47f75314cb1cd8db894ed7312dfadca2",
    "id": null,
    "metadata": {},
    "name": "MyEntriesDisplayQuery",
    "operationKind": "query",
    "text": "query MyEntriesDisplayQuery(\n  $contestId: ID!\n) {\n  entrantsForContest(contestId: $contestId) {\n    id\n    username\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '203faa3a87b46e79a56dd92953c34ea7';

module.exports = node;
